import React from 'react';
import {TextContainer, DisplayText} from '@shopify/polaris';
import {isTestMode} from './helpers/test_mode';

export const Header = () => {
  const title = `Hire a Shopify expert${isTestMode() ? ' (Test Mode)' : ''}`;

  return (
    <TextContainer>
      <DisplayText size="large">{title}</DisplayText>
    </TextContainer>
  );
};

export default Header;
